import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "./supabaseClient";
import "./App.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSignup, setIsSignup] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  async function handleAuth(e) {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    const { error } = isSignup
      ? await supabase.auth.signUp({ email, password })
      : await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setMessage(error.message);
    } else {
      setMessage(
        isSignup
          ? "Check your email to confirm sign up."
          : "Logged in! Redirecting..."
      );
      if (!isSignup) {
        setTimeout(() => navigate("/app"), 1200);
      }
    }

    setLoading(false);
  }

  async function handleResetPassword() {
    if (!email) {
      setMessage("Enter your email to reset your password.");
      return;
    }

    const redirectTo =
      process.env.REACT_APP_REDIRECT_URL || "http://localhost:3000/update-password";

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo,
    });

    if (error) {
      setMessage("Error: " + error.message);
    } else {
      setMessage("Check your email to reset your password.");
    }
  }

  return (
    <div className="auth-wrapper">
      <div className="login-container">
        <div className="login-header">
          <img src="/realmaplogo.png" alt="RealMap logo" className="login-logo" />
          <h1 className="app-title login-title">Real Maps</h1>
        </div>

        <h2>{isSignup ? "Sign Up" : "Log In"}</h2>

        {message && <p className="login-message">{message}</p>}

        <form onSubmit={handleAuth}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Loading..." : isSignup ? "Sign Up" : "Log In"}
          </button>
        </form>

        <p className="auth-toggle" onClick={handleResetPassword}>
          Forgot Password?
        </p>

        <p className="auth-toggle" onClick={() => setIsSignup(!isSignup)}>
          {isSignup
            ? "Already have an account? Log in"
            : "New? Sign up here"}
        </p>
      </div>
    </div>
  );
}
